module.exports = __webpack_public_path__ + "img/table-delc-icon-white.c434fc71.svg";